export default "__VITE_ASSET__BNjtk8K8__"